<template>
  <div
    class="fixed-btn"
    v-if="showMoreBtn"
  >
    <!-- 悬浮按钮 去到底部 -->
    <img
      src="@/assets/img/orderGeneral/order_show_more@2x.png"
      @click="clickHandler"
    >
  </div>
</template>

<script>
export default {
  name: 'ShowMore',
  props: {
    wrapBox: {
      type: String,
      default: 'top-box'
    }
  },
  data() {
    return {
      observer: null,
      topBoxEl: null,
      showMoreBtn: false
    };
  },
  mounted() {
    const topBoxEl = document.getElementsByClassName(this.wrapBox)[0];
    this.observer = new MutationObserver((mutationsList, observer) => {
      this.topBoxEl = document.getElementsByClassName(this.wrapBox)[0];
      this.getShowMoreBtn();
      if (this.topBoxEl) {
        this.topBoxEl.removeEventListener('scroll', this.scrollHandler);
        this.topBoxEl.addEventListener('scroll', this.scrollHandler);
        const currentScrollTop = localStorage.getItem('currentScrollTop');
        if (currentScrollTop) {
          this.topBoxEl.scrollTop = currentScrollTop;
          localStorage.removeItem('currentScrollTop');
        }
      }
    });

    this.observer.observe(topBoxEl, {
      attributes: true, childList: true, subtree: true
    });
  },
  destroyed() {
    this.observer && this.observer.disconnect();
    this.observer = null;
    this.topBoxEl && this.topBoxEl.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    clickHandler() {
      this.showMoreHandler();
    },
    showMoreHandler() {
      const el = document.getElementsByClassName(this.wrapBox)[0];
      el.scrollTop = el.scrollHeight;
      this.getShowMoreBtn();
    },
    scrollHandler() {
      this.getShowMoreBtn();
    },
    getShowMoreBtn() {
      console.log('======getShowMoreBtn=====');
      console.log('this.topBoxEl.scrollHeight: ', this.topBoxEl.scrollHeight);
      console.log('this.topBoxEl.clientHeight: ', this.topBoxEl.clientHeight);
      console.log('this.topBoxEl.scrollTop: ', this.topBoxEl.scrollTop);
      console.log('======getShowMoreBtn=====');
      this.showMoreBtn =
        this.topBoxEl &&
        this.topBoxEl.scrollHeight > window.screen.height &&
        this.topBoxEl.clientHeight + this.topBoxEl.scrollTop < this.topBoxEl.scrollHeight;
    },
    setCurrentScrollTop() {
      const currentScrollTop = this.topBoxEl.scrollTop;
      currentScrollTop > 0 && localStorage.setItem('currentScrollTop', currentScrollTop);
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-btn{
  position: fixed;
  bottom: 72px;
  left: 50%;

  width: 52px;
  height: 52px;

  transform: translateX(-50%);

  img{
    width: 100%;
    height: 100%;
  }
}
</style>
